
// This helper provides support for showing/hiding the Loading indicator
// If simplifies dealing with the indicator when we can have various Modules interacting with it.

var LoadingIndicator = function(loadingLatch) {
   var lastKey = 0,
       keyCounters = {};

   return {

      // Every client of this object should request a key before interacting with it
      getLoadingKey:function() {
          return ++lastKey;
      },

      showLoading: function(key, msg) {
          if(keyCounters[key] === undefined) keyCounters[key] = 0;

          loadingLatch.increment(msg);
          keyCounters[key]++;
      },

      hideLoading: function(key, msg) {
          if(keyCounters[key] === undefined) return;

          if(keyCounters[key] > 0){
             loadingLatch.decrement(msg);
             keyCounters[key]--;
          }
      },

      reset: function(msg){
          keyCounters = {};

          loadingLatch.reset(msg);
      }

   }
};

export default LoadingIndicator;
